export class Checkbox {
  id!: string;
  title!: string;
  checked: boolean = false;
}
